import { IconButton, Link, Tooltip } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';

export const ErpLink = ({
  windowName,
  query = {},
  text,
  title = 'Open in Prophet 21',
  style = {},
  openWindowIcon = false,
  windowSx = {},
  color = 'primary',
  variant = 'body',
}) => {
  const queryString = Object.keys(query)
    .filter(
      (k) => query[k] !== undefined && query[k] !== null && query[k] !== ''
    )
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(query[k])}`)
    .join('&');

  if (openWindowIcon)
    return (
      <Tooltip title={title}>
        <IconButton
          windowSx={windowSx}
          color={color}
          onClick={() =>
            window.open(
              `${process.env.NEXT_PUBLIC_P21_URL}/Prophet21/#/window/m_${windowName}?${queryString}`,
              '_blank'
            )
          }
        >
          <LaunchIcon />
        </IconButton>
      </Tooltip>
    );

  return (
    <Link
      href={`${process.env.NEXT_PUBLIC_P21_URL}/Prophet21/#/window/m_${windowName}?${queryString}`}
      target='_blank'
      title={title}
      style={style}
      variant={variant}
    >
      {text}
    </Link>
  );
};
